import React from 'react';
import { appDocumentTitle } from '../../appMeta';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';
import { QuotationListTabScreen } from './TabScreens/List';

export { QuotationDetailRoute } from './QuotationDetailRoute';
export { QuotationFormRoute } from './QuotationFormRoute';
export { QuotationWorkOrderCreateRoute } from './QuotationWorkOrderCreateRoute';

export function QuotationsPage() {
  useDocumentTitle(appDocumentTitle('Quotation'));

  return (
    <PageShell title="Quotation">
      <QuotationListTabScreen />
    </PageShell>
  );
}
